<template>
    <div ref="dropdownWrapper"
        :class="['inline-flex flex-shrink-0 items-center space-x-2 bg-white rounded-full py-1 pr-1 pl-4 shadow-[0px_0px_10px_0px_#00000026] mobile:hidden tablet:flex', globalEntitiesClass]">
        <span class="text-[14px] largeDesktop:text-[16px] font-roboto text-[#333333] whitespace-nowrap">Show entries</span>
        <div class="relative">
            <button
                class="flex items-center justify-between px-3 py-1 w-20 text-[14px] largeDesktop:text-[16px] text-white bg-[#7286D3] rounded-full focus:outline-none"
                @click="toggleDropdown">
                {{ selected }}
                <img src="../../assets/images/up-doen-arrow.svg" alt="Up Down Arrow" class="w-5 h-5">
            </button>
            <ul v-if="isOpen" class="absolute z-10 mt-1 w-full bg-white rounded shadow-lg text-gray-700 text-sm p-0">
                <li v-for="option in options" :key="option"
                    class="px-4 py-2 hover:bg-indigo-100 cursor-pointer text-center" @click="select(option)">
                    {{ option }}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        globalEntitiesClass: {
            type: String,
            default: '',
        },
        modelValue: {
            type: Number,
            default: 5,
        },
    },
    data() {
        return {
            options: [25, 50, 100],
            isOpen: false,
        };
    },
    computed: {
        selected: {
            get() {
                return this.modelValue;
            },
            set(val) {
                this.$emit('update:modelValue', val);
            },
        },
    },
    mounted() {
        document.addEventListener('click', this.handleClickOutside);
    },
    unmounted() {
        document.removeEventListener('click', this.handleClickOutside);
    },
    methods: {
        toggleDropdown() {
            this.isOpen = !this.isOpen;
        },
        select(value) {
            this.selected = value;
            this.isOpen = false;
            this.$emit('update:entries', value); // emit change if needed
        },
        handleClickOutside(event) {
            if (this.isOpen && !this.$refs.dropdownWrapper.contains(event.target)) {
                this.isOpen = false;
            }
        },
    },
};
</script>
